var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLuggage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "luggage_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#luggage_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.111 35H8.333V10h6.806V3.333h9.722V10h6.806v25h-2.778c0 .472-.16.868-.48 1.188-.319.319-.715.479-1.187.479-.472 0-.868-.16-1.187-.48-.32-.319-.48-.715-.48-1.187h-11.11c0 .472-.16.868-.48 1.188-.319.319-.715.479-1.187.479-.472 0-.868-.16-1.188-.48-.319-.319-.479-.715-.479-1.187Zm0-2.778H28.89V12.778H11.11v19.444ZM15.14 30h2.778V15h-2.778v15Zm6.944 0h2.778V15h-2.778v15Zm-4.166-20h4.166V6.111h-4.166V10Z"
}))));
export default SvgLuggage;